import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon, Loader, Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import { useGeneralParams } from '../GeneralParams';
import { useStitchMembers } from '../StitchMembers';
import { useTwilioDevice } from './useTwilioDevice';

const Small = styled.span`
  font-size: 12px;
  font-style: italic;
`;

const StyledLink = styled.span`
  text-decoration: underline;
  color: black;
`;

export default function CallModal() {
  const {
    callModalOpen,
    setCallModalOpen,
    setOngoingCall,
  } = useGeneralParams();
  const { memberOne } = useStitchMembers();

  // Use the custom Twilio Device hook
  const {
    device,
    status,
    loading,
    isOnCall,
    makeCall,
    hangUp,
    resetStatus,
  } = useTwilioDevice(callModalOpen);

  useEffect(() => {
    setOngoingCall(isOnCall);
  }, [setOngoingCall, isOnCall]);

  return memberOne  ? (
    <Modal
      size={'tiny'}
      open={callModalOpen}
      onClose={() => {
        setCallModalOpen(false);
      }}
    >
      <Modal.Header>Call Member {memberOne.name}</Modal.Header>
      <Modal.Content>
        {loading ? (
          <Loader active inline='centered'>Initializing call system...</Loader>
          ) : (
          <>
          {status}
          <br />
          <br />
          {status === 'Call completed.' ? (
          <>
            View call logs{' '}
            <Link
              onClick={() => {
                resetStatus();
                setCallModalOpen(false);
              }}
              to={`/member-details/${memberOne._id}/phone-calls`}
            >
              <StyledLink>here</StyledLink>
            </Link>
            . They may take a minute to update.
          </>
        ) : (
          <span>
            Make sure your volume and microphone are on.
            <br />
            <span className="red text">
              ALSO, PLEASE COMMUNICATE WITH THE PATIENT THAT THE CALL
              WILL BE TRANSCRIBED FOR CARE-MANAGEMENT PURPOSES.
            </span>
            <br />
            The trascripts will be accessible at{' '}
            <Link
              to={`/member-details/${memberOne._id}/phone-calls`}
            >
              <StyledLink># phone-calls</StyledLink>
            </Link>
          </span>
        )}
          </>
        )}
      </Modal.Content>
      <Modal.Actions>
        {device && !isOnCall && (
          <Button
            color="blue"
            onClick={() => makeCall(memberOne.phone)}
          >
            <Icon name="phone" /> Call <Small>({memberOne.phone})</Small>
          </Button>
        )}
        <Button
          color="red"
          onClick={() => {
            if (isOnCall) {
              hangUp();
            } else {
              resetStatus();
              setCallModalOpen(false);
            }
          }}
        >
          <Icon name="x" /> {isOnCall ? 'Hang Up' : 'Close'}
        </Button>
      </Modal.Actions>
    </Modal>
  ) : (
    <></>
  );
}
